module.exports = __webpack_public_path__ + "images/icons/icon-edit-6c8cc908.svg";